import React, { useRef, useState } from "react";
import ActivityLoader from "../../Common/ActivityLoader";
import functions from "../../../util/functions";
import { numberFormat } from "../../../util/araknerdlib";
import { useCurrency } from "../../../util/SystemVariables";
import DashCardHeader from "../../Dashboard/DashCardHeader";

const FeeCard = ({ fee, isHighlighted, onSelect, onManage, currency }) => (
  <div 
    className={`flex-shrink-0 transition-all ${isHighlighted ? 'ring-active' : ''}`}
    style={{ 
      width: '320px', 
      scrollSnapAlign: 'start',
      cursor: 'pointer' 
    }}
    onClick={() => onSelect(fee.group_info.id)}
  >
    <div className="card border shadow-sm border-0" style={{ borderRadius: '16px', backgroundColor: '#FFFFFF', height: '55vh' }}>
      <div className="card-body p-4">
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div className="text-truncate mr-2" style={{ maxWidth: '180px' }}>
            <h6 className="font-weight-bold text-dark mb-0 text-truncate">{fee.group_info.group_name}</h6>
            <small className="text-muted text-truncate d-block">{fee.group_info.description}</small>
          </div>
          <span className="badge-soft-indigo px-2 py-1 d-flex align-items-center" style={{ fontSize: '10px', backgroundColor: '#EEF2FF', color: '#4F46E5', borderRadius: '6px' }}>
            <i className="fa fa-users mr-1"></i> {numberFormat(fee.total_students)}
          </span>
        </div>

        <div className="rounded-lg p-3 text-center mb-4" style={{ background: '#F8FAFC' }}>
          <small className="text-muted font-weight-bold text-uppercase" style={{ fontSize: '9px', letterSpacing: '0.05em' }}>Total Fee Amount</small>
          <h4 className="font-weight-bold mb-3 mt-1" style={{ color: '#4F46E5' }}>
            <span style={{ fontSize: '12px' }}>{currency}</span> {numberFormat(fee.group_info.amount)}
          </h4>
         { onManage && (
            <button 
            className="btn btn-primary btn-block btn-sm py-2 font-weight-bold" 
            style={{ borderRadius: '8px', backgroundColor: '#4F46E5', border: 'none' }}
            onClick={(e) => { e.stopPropagation(); onManage(); }}
          >
            Manage Structure
          </button>)}
        </div>

        <p className="small font-weight-bold text-muted text-uppercase mb-2" style={{ fontSize: '10px' }}>Structure Preview</p>
        <div className="overflow-auto hide-scrollbar" style={{ maxHeight: '200px' }}>
          <ul className="list-unstyled mb-0">
            {Array.isArray(fee.structure?.votes) && fee.structure.votes.map((vote, idx) => (
              <li key={idx} className="d-flex justify-content-between mb-2 pb-1" style={{ borderBottom: '1px dashed #E2E8F0' }}>
                <span className="text-secondary small text-truncate mr-2">{vote.vote?.vote_name}</span>
                <span className="font-weight-bold text-dark small">{functions.numberFormat(vote.amount)}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </div>
);

const BillingStructure = ({ feesStructure, handleManage, onSelect }) => {
  const scrollContainerRef = useRef(null);
  const [active, setActive] = useState(null);
  const currency = useCurrency();

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const { scrollLeft, clientWidth } = scrollContainerRef.current;
      const scrollTo = direction === 'left' ? scrollLeft - clientWidth / 1.5 : scrollLeft + clientWidth / 1.5;
      scrollContainerRef.current.scrollTo({ left: scrollTo, behavior: 'smooth' });
    }
  };

  return (
    <DashCardHeader title="Billing Structures" description="Use arrows or scroll to view all groups" iconClass="fas fa-layer-group">
      <div className="position-relative billing-scroller-wrapper">
        <style>{`
          .billing-scroller-wrapper .nav-arrow {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            z-index: 10;
            width: 40px;
            height: 40px;
            background: #FFFFFF;
            color: #4F46E5;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 4px 12px rgba(0,0,0,0.1);
            border: 1px solid #E2E8F0;
            cursor: pointer;
            opacity: 0;
            transition: all 0.3s ease;
          }
          .billing-scroller-wrapper:hover .nav-arrow { opacity: 1; }
          .billing-scroller-wrapper .nav-arrow:hover { background: #4F46E5; color: #FFF; }
          .billing-scroller-wrapper .arrow-left { left: -10px; }
          .billing-scroller-wrapper .arrow-right { right: -10px; }
          .hide-scrollbar::-webkit-scrollbar { display: none; }
          .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
        `}</style>

        {/* Navigation Arrows */}
        <div className="nav-arrow arrow-left" onClick={() => scroll('left')}>
          <i className="fa fa-chevron-left"></i>
        </div>
        <div className="nav-arrow arrow-right" onClick={() => scroll('right')}>
          <i className="fa fa-chevron-right"></i>
        </div>
        
        <div 
          className="d-flex flex-nowrap overflow-auto hide-scrollbar py-4 px-2" 
          ref={scrollContainerRef}
          style={{ gap: '20px', scrollSnapType: 'x mandatory', scrollBehavior: 'smooth', maxWidth: '65vw' }}
        >
          {Array.isArray(feesStructure) ? (
            feesStructure.map((fee, index) => (
              <FeeCard
                key={index}
                fee={fee}
                isHighlighted={active === fee.group_info.id}
                onSelect={onSelect ? (v) => { setActive(v); onSelect(fee); } : (v) => setActive(v)}
                onManage={handleManage ? () => handleManage(fee) : undefined}
                currency={currency}
              />
            ))
          ) : (
            <div className="w-100 text-center py-5"><ActivityLoader /></div>
          )}
        </div>
      </div>
    </DashCardHeader>
  );
};

export default BillingStructure;